<perfect-scrollbar class="side-nav" sideNav>
    <ul class="ant-menu ant-menu-root ant-menu-inline side-nav-menu"
        [ngClass]="{
            'ant-menu-inline-collapsed': isFolded
        }"
    >
        <li [ngClass]="item.children.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
            *ngFor="let item of menuItems"
            [routerLinkActive]="item.children.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
            [routerLinkActiveOptions]="{exact: true}">
            <a href="javascript:void(0);" class="ant-menu-submenu-title" *ngIf="item.children.length > 0">
                <i-tabler [name]="item.icon ?? 'menu-2'" class="anticon tb-icon tb-icon-m center mr-1"></i-tabler>
                <span>{{item.displayName}}</span>
                <i class="ant-menu-submenu-arrow"></i>
            </a>
            <a [routerLink]="item.uri" (click)="closeMobileMenu()" *ngIf="item.children.length === 0">
                <i-tabler [name]="item.icon ?? 'menu-2'" class="anticon tb-icon tb-icon-m center mr-1"></i-tabler>
                <span>{{item.displayName}}</span>
            </a>

            <!-- Second Level -->
            <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu" *ngIf="item.children.length > 0">
                <li [ngClass]="subItem.children.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
                    *ngFor="let subItem of item.children"
                    [routerLinkActive]="subItem.children.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
                    [routerLinkActiveOptions]="{exact: true}">
                    <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-25" *ngIf="subItem.children.length > 0">
                        <i-tabler [name]="subItem.icon ?? 'menu-2'" class="anticon tb-icon tb-icon-m center mr-1"></i-tabler>
                        <span>{{subItem.displayName}}</span>
                        <i class="ant-menu-submenu-arrow"></i>
                    </a>
                    <a [routerLink]="subItem.uri" (click)="closeMobileMenu()" class="p-l-10" *ngIf="subItem.children.length === 0">
                        <i-tabler [name]="subItem.icon ?? 'menu-2'" class="anticon tb-icon tb-icon-m center mr-1"></i-tabler>
                        <span>{{subItem.displayName}}</span>
                    </a>

                    <!-- Third Level -->
                    <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu" *ngIf="subItem.children.length > 0">
                        <li [ngClass]="subItem.children.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
                            *ngFor="let subItem of subItem.children" routerLinkActive="ant-menu-item-selected"
                            [routerLinkActiveOptions]="{exact: true}">
                            <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-25" *ngIf="subItem.children.length > 0">
                                <i-tabler [name]="subItem.icon ?? 'menu-2'" class="anticon tb-icon tb-icon-m center mr-1"></i-tabler>
                                <span>{{subItem.displayName}}</span>
                                <i class="ant-menu-submenu-arrow"></i>
                            </a>
                            <a [routerLink]="subItem.uri" (click)="closeMobileMenu()" class="p-l-25" *ngIf="subItem.children.length === 0">
                                <i-tabler [name]="subItem.icon ?? 'menu-2'" class="anticon tb-icon tb-icon-m center mr-1"></i-tabler>
                                <span>{{subItem.displayName}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</perfect-scrollbar>
